import { H4, Image, LI, P, UL } from "../../../../AbstractElements";
import { recentContactData } from "../../../../Data/Dashboard/CryptoDashboard/CryptoDashboard";
import { dynamicImage } from "../../../../Service";
import { RecentContactHeading } from "../../../../utils/Constant";

const RecentContact = () => {
  return (
    <>
      <H4>{RecentContactHeading}</H4>
      <UL className="simple-list flex-row">
        {recentContactData.map((data, i) => (
          <LI key={i}>
            <Image src={dynamicImage(`dashboard/user/${data.image}`)} alt="user" />
            <P className="f-w-600">{data.name}</P>
            <span>{data.email}</span>
            <div className="active-status active-online" />
          </LI>
        ))}
      </UL>
    </>
  );
};

export default RecentContact;
